/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-props-no-spreading */
import React, { ImgHTMLAttributes, useRef } from 'react';
import { getCurrentHub } from '@sentry/nextjs';
import ContentComposer, { ComponentProps } from '../../ContentComposer';
import * as S from './styles';
import { srcSetDictionary } from '..';

export interface CustomImageComponent extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  width?: number;
  height?: number;
  alt?: string;
  figcaption?: string | string[] | ComponentProps[];
  srcset?: { [key: number]: string };
  hasTarja?: boolean;
  isHeader?: 'internal' | 'full';
}

export default function HeaderImageComponent({
  src,
  alt,
  figcaption = undefined,
  srcset = undefined,
  width = undefined,
  height = undefined,
  hasTarja = undefined,
  isHeader = undefined,
}: CustomImageComponent) {
  const currentSpan = getCurrentHub().getScope()?.getSpan();
  const imageComponentSpan = currentSpan && currentSpan.startChild({ op: 'imageComponent', description: src });
  const headerProps = {};

  if (isHeader) Object.assign(headerProps, { isHeader });

  const image = useRef<HTMLImageElement>();

  return (
    <S.ContainerImage style={{ width: width || '100%', height: height || '100%' }} hasTarja={!!hasTarja} {...headerProps}>
      <img
        src={src}
        ref={image}
        // Filtra entradas inválidas antes de montar o srcset:
        // - URL vazia/undefined → entrada viraria ` ${width}w` (sem URL), o
        //   browser interpreta a width sozinha como URL relativa e quebra a img.
        // - Chave fora do `srcSetDictionary` (ex.: backend retorna `1500` ou
        //   `2560`) → atributo viraria `url undefinedw`, inválido.
        srcSet={
          srcset
            ? Object.entries(srcset)
                .filter(([key, url]) => Boolean(url) && srcSetDictionary[key] !== undefined)
                .map(([key, url]) => `${url} ${srcSetDictionary[key]}w`)
                .join(', ') || undefined
            : undefined
        }
        sizes="(max-width: 992px) 100vw, 60vw"
        alt={alt}
        width={width && width}
        height={height && height}
        decoding="async"
        {...({ fetchpriority: 'high' } as any)}
      />
      {figcaption && (
        <S.CaptionImage>
          {figcaption && figcaption !== undefined && figcaption.length > 0 && typeof figcaption === 'string'
            ? figcaption
            : Array.isArray(figcaption) &&
              figcaption?.map((figcapitem, id) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={`${typeof figcapitem === 'string' ? figcapitem : figcapitem.valor}-${id}`}>
                  {figcapitem && typeof figcapitem === 'string' && figcapitem?.length > 0
                    ? figcapitem
                    : typeof figcapitem === 'object' && (
                        <ContentComposer
                          tipo={figcapitem?.tipo}
                          url={figcapitem.url}
                          as={figcapitem?.tag}
                          valor={figcapitem?.valor}
                          target={figcapitem.target}
                        />
                      )}
                </React.Fragment>
              ))}
          {imageComponentSpan && imageComponentSpan.finish()}
        </S.CaptionImage>
      )}
    </S.ContainerImage>
  );
}
